// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"aceb6001","453":"63ed6739","644":"78b09f15","667":"9359b689"}[chunkId] + ".chunk.js";
};